var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      staticClass: "p-4 question-container background-white",
      attrs: { xs12: "" },
    },
    [
      _c("div", { staticClass: "d-none type-question" }, [
        _vm._v(_vm._s(_vm.currentQuestion.fieldType)),
      ]),
      _vm._v(" "),
      _vm.isMultipleQuestion
        ? _c("span", { staticClass: "title" }, [
            _vm._v(
              " " + _vm._s(_vm.groupIndex) + " - " + _vm._s(_vm.index) + " "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "text-sm-start bg-white", attrs: { xs12: "" } },
        [
          _c(
            "strong",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentQuestion.isTestQuestion,
                  expression: "currentQuestion.isTestQuestion",
                },
              ],
              staticClass: "text-large",
            },
            [_vm._v("Question")]
          ),
          _vm._v(" "),
          _vm.show
            ? _c("div", {
                staticClass: "question-body-preview-client subheading px-1",
                domProps: { innerHTML: _vm._s(_vm.content) },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "strong",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentQuestion.isTestQuestion,
              expression: "currentQuestion.isTestQuestion",
            },
          ],
          staticClass: "text-large",
        },
        [_vm._v("User Answer")]
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "mx-0 pb-4 bg-white" },
        [
          _vm.currentQuestion.isTextarea && _vm.getAnswerMode()
            ? _c("div", {
                staticClass: "markdown-editor w-full fill-height",
                staticStyle: { "min-height": "560px" },
                attrs: { id: "editor" },
              })
            : _vm.currentQuestion.isTextarea
            ? _c("div", {
                staticClass:
                  "textarea-preview question-white-bgr mt-0 p-3 mb-1",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.markdownParser(
                      _vm.value.length
                        ? _vm.value[0] || _vm.value[_vm.value.length - 1]
                        : ""
                    )
                  ),
                },
              })
            : _vm.currentQuestion.isCheckbox ||
              _vm.currentQuestion.isMultiCheckbox ||
              _vm.currentQuestion.isSelect
            ? _c("QuestionCheckBox", {
                attrs: {
                  list: _vm.currentQuestion.answerItemsView
                    ? _vm.currentQuestion.answerItemsView
                    : [],
                  trueBgr: _vm.exam.autoDiagnosisEnabled ? "#fff" : "#bce0fd",
                  value: _vm.value ? _vm.value : [],
                  color: "white",
                  readonly: "",
                },
              })
            : _vm.currentQuestion.isRadio
            ? _c("QuestionRadio", {
                attrs: {
                  list: _vm.currentQuestion.answerItemsView
                    ? _vm.currentQuestion.answerItemsView
                    : [],
                  trueBgr: _vm.exam.autoDiagnosisEnabled ? "#fff" : "#bce0fd",
                  value: _vm.value.length
                    ? _vm.value.find(function (x) {
                        return !!x
                      })
                    : "",
                  color: "white",
                  readonly: "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      (_vm.currentQuestion.skills && _vm.currentQuestion.skills.length > 0) ||
      _vm.explanation
        ? [
            _c(
              "v-flex",
              { staticClass: "explain-title m-0 ps-1 text-secondary" },
              [_vm._v("解説")]
            ),
            _vm._v(" "),
            _vm.currentQuestion.isTextarea
              ? _c("div", { staticClass: "summary-sore" }, [
                  _c("span", { staticClass: "percent-number" }, [
                    _vm._v(
                      _vm._s(Math.round((_vm.userScore / _vm.maxScore) * 100))
                    ),
                  ]),
                  _c("span", { staticClass: "percent" }, [_vm._v("%")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.userScore) +
                        "/" +
                        _vm._s(_vm.maxScore) +
                        " 点中"
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticClass: "bg-white" },
              [
                _vm._l(_vm.currentQuestion.skills, function (skill, index) {
                  return _c(
                    "v-flex",
                    { key: "skill" + index },
                    [
                      skill.name.trim() != "addition_from_ai"
                        ? _c("p", { staticClass: "skill-text ps-1 my-3" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(skill.name) +
                                " > " +
                                _vm._s(_vm.skillItemsName(skill)) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      skill.gptAssessments[0] &&
                      skill.gptAssessments[0].data.skills[skill.id]
                        ? [
                            skill.name.trim() != "addition_from_ai"
                              ? _c("table", { staticClass: "skill-table" }, [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Criteria")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Score")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Explanation")]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(
                                        skill.gptAssessments[0].data.skills[
                                          skill.id
                                        ].skillItems,
                                        function (item, index) {
                                          return _c(
                                            "tr",
                                            { key: "item-" + index },
                                            [
                                              _c("td", [
                                                _vm._v(_vm._s(item.name)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(item.answer.score) +
                                                    "/" +
                                                    _vm._s(
                                                      _vm.getMaxScore(
                                                        skill,
                                                        item.name
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    item.answer.reason
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "tr",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _c("td", [_vm._v("合計スコア")]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                Array.from(
                                                  Object.values(
                                                    skill.gptAssessments[0].data
                                                      .skills[skill.id]
                                                      .skillItems
                                                  )
                                                )
                                                  .map(function (item) {
                                                    return item.answer.score
                                                  })
                                                  .reduce(function (
                                                    accumulator,
                                                    currentValue
                                                  ) {
                                                    return (
                                                      accumulator + currentValue
                                                    )
                                                  },
                                                  0)
                                              ) +
                                                "/" +
                                                _vm._s(
                                                  Array.from(
                                                    Object.values(
                                                      skill.gptAssessments[0]
                                                        .data.skills[skill.id]
                                                        .skillItems
                                                    )
                                                  )
                                                    .map(function (item) {
                                                      return _vm.getMaxScore(
                                                        skill,
                                                        item.name
                                                      )
                                                    })
                                                    .reduce(function (
                                                      accumulator,
                                                      currentValue
                                                    ) {
                                                      return (
                                                        accumulator +
                                                        currentValue
                                                      )
                                                    },
                                                    0)
                                                ) +
                                                "\n                "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td"),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              skill.gptAssessments[0].data.skills[
                                String(skill.id)
                              ].skillItems,
                              function (item, index) {
                                return !item.answer.hasOwnProperty("score")
                                  ? _c(
                                      "div",
                                      {
                                        key: "item-" + index,
                                        staticClass: "other-gpt-assessments",
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.camelCaseToWords(item.name)
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(item.answer),
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e()
                              }
                            ),
                          ]
                        : _vm.exam.isResultAfterQuestion
                        ? _c(
                            "p",
                            [
                              _c("v-progress-circular", {
                                staticClass: "loading",
                                attrs: { indeterminate: "", color: "green" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "exam-explain px-1",
                  domProps: { innerHTML: _vm._s(_vm.explanation) },
                }),
                _vm._v(" "),
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "800" },
                    model: {
                      value: _vm.codeDialog,
                      callback: function ($$v) {
                        _vm.codeDialog = $$v
                      },
                      expression: "codeDialog",
                    },
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-text", {
                          staticClass: "d-flex pt-6",
                          domProps: { innerHTML: _vm._s(_vm.dialogHTML) },
                        }),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary" },
                                on: {
                                  click: function ($event) {
                                    _vm.codeDialog = false
                                  },
                                },
                              },
                              [_vm._v("近い")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.qScoreHistorySummary &&
      _vm.currentQuestion.isTestQuestion &&
      _vm.qScoreHistorySummary.totalCount > 1
        ? [
            _c(
              "div",
              {
                staticClass:
                  "explain-title m-0 ps-1 text-secondary d-flex py-1",
              },
              [
                _vm._v(
                  "\n        正解率 " +
                    _vm._s(_vm.qScoreHistorySummary.rate) +
                    "%（" +
                    _vm._s(_vm.qScoreHistorySummary.successCount) +
                    "/" +
                    _vm._s(_vm.qScoreHistorySummary.totalCount) +
                    "）\n        "
                ),
                _c("div", { staticClass: "text-gray ms-2" }, [
                  _vm._v(
                    "いままで " +
                      _vm._s(_vm.qScoreHistorySummary.totalCount) +
                      "回やって" +
                      _vm._s(_vm.qScoreHistorySummary.successCount) +
                      "回正解しています"
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ps-2 list-question-history" },
              _vm._l(
                _vm.qScoreHistorySummary.histories,
                function (history, index) {
                  return _c(
                    "v-row",
                    { key: index },
                    [
                      _c("v-col", { attrs: { cols: "2" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.dateFormat(history.createdAt)) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "blue-text", attrs: { cols: "2" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(history.score > 0 ? "正解" : "不正解") +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-col", { attrs: { cols: "7" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.examQScoreHistory.examName) +
                            " - " +
                            _vm._s(_vm.getNameByExamType(history.examType)) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  )
                }
              ),
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.currentQuestion.coursesWithLessons &&
      _vm.currentQuestion.coursesWithLessons.length > 0 &&
      _vm.schoolSetting.useCourseLesson
        ? [
            _c("v-flex", { staticClass: "explain-title p-2 text-secondary" }, [
              _vm._v("参考レッスン"),
            ]),
            _vm._v(" "),
            _vm._l(
              _vm.currentQuestion.coursesWithLessons,
              function (courseWithLessons) {
                return _c(
                  "v-flex",
                  {
                    key: courseWithLessons.course.id,
                    staticClass: "bg-white p-2",
                  },
                  [
                    _c("router-link", {
                      staticClass: "me-4",
                      attrs: {
                        to: "/classroom/courses/" + courseWithLessons.course.id,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var href = ref.href
                              return [
                                _c(
                                  "a",
                                  { attrs: { href: href, target: "_blank" } },
                                  [
                                    _vm._v(
                                      _vm._s(courseWithLessons.course.name)
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _vm._l(courseWithLessons.lessons, function (lesson) {
                      return _c(
                        "div",
                        { key: lesson.id, staticClass: "lesson-margin" },
                        [
                          _c("router-link", {
                            attrs: {
                              to:
                                "/classroom/courses/" +
                                courseWithLessons.course.id +
                                "?lesson_id=" +
                                lesson.id,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var href = ref.href
                                    return [
                                      _c("a", { attrs: { href: href } }, [
                                        _vm._v(_vm._s(lesson.name)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              }
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }